import { render, staticRenderFns } from "./DeletedCardsModal.vue?vue&type=template&id=46f3bf94"
import script from "./DeletedCardsModal.vue?vue&type=script&lang=js"
export * from "./DeletedCardsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports